import React from 'react';

export const WarningAlert = () => (
  <div className="p2-warning-alert">
    <div className="p2-warning-alert-title">Pending Cluster Creation</div>
    <div className="p2-warning-alert-body">
      Pending clusters are built within 30 minutes of creation. Upon creation, an email notification will be sent. Once
      complete, the new cluster will be available as an option for new deployments. If you are still waiting for a
      cluster to be created, please contact <a href="mailto:support@phasetwo.io">support@phasetwo.io</a>.
    </div>
  </div>
);

export const ExceptionAlert = () => (
  <div className="p2-warning-alert">
    <div className="p2-warning-alert-title">Setup Exception</div>
    <div className="p2-warning-alert-body">
      There has been an exception in the setup of your cluster. We have alerted our ops team and will diagnose and fix
      the issue right away. We will reach out with another notification once the issue has been resolved.
    </div>
  </div>
);
